var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.f3ec8aeb00f526756c07bfad4d0e53d1.svg#c';
                    var viewUrl = 'sprites.f3ec8aeb00f526756c07bfad4d0e53d1.svg#view-c';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };